module.exports = __webpack_public_path__ + "img/icon-retirement.2e60a01d.svg";